import { uiStore } from '@/stores/ui.store';
import { userStore } from '@/stores/user.store';

import { REFERRAL_BANNER_MIN_ACCOUNT_AGE_DAYS } from './referral.constants';

export const isReferralBannerVisible = (): boolean => {
  if (uiStore.referralCardDismissed) return false;

  const accountAgeDays = userStore.accountAgeDays;
  if (accountAgeDays === null) return false;

  return accountAgeDays >= REFERRAL_BANNER_MIN_ACCOUNT_AGE_DAYS;
};
